import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'

export default class Modalseditgroup extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",
   id_send:"",
   id_room:"",
   name_room:"",
   amount:"",
   id:"",
   building:[],
   building_id:'',


   teacher_id1:'',
   id_major:'',
   id_course:'',
   group_id:'',
   poname:'',
}

//this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChange4 = this.handleChange4.bind(this);
this.getbuilding = this.getbuilding.bind(this);
this.onChange = this.onChange.bind(this);

}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  //this.props.getclassroom();
  //const { id_send } = this.props.name_room
   //   console.log(id_send);
       this.setState({ teacher_id1:this.props.teacher_id1})
       this.setState({ id_major:this.props.id_major})
       this.setState({ id_course:this.props.id_course})
       this.setState({ group_id:this.props.group_id})
        this.setState({ poname:this.props.poname})
 this.getbuilding()   

}


 componentDidMount() {
    //  const { id_send } = this.props.id_send
    //  console.log(id_send);
       this.setState({ teacher_id1:this.props.teacher_id1})
       this.setState({ id_major:this.props.id_major})
       this.setState({ id_course:this.props.id_course})
       this.setState({ group_id:this.props.group_id})
        this.setState({ poname:this.props.poname})
  }

  getbuilding() {

     setTimeout(() => {
      //ภายใน
       Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getbuilding')
         // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
      .then(res => {
     //   console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ building: res.data})
        this.setState({ loading: false})
      }) 
    }, 0);

  }


  onChange(value) {
     console.log(`selected ${value}`);




 // Axios.get('https://mua.kpru.ac.th/FrontEnd_Mis/employee/procSEmpInfo/'+value)
  //  .then(res => {
     // console.log(res.data.procSEmpInfo[0].citizen_id);
    //  this.setState({ bankname: res.data, loading: false })
   //   this.setState({ citizen_id: res.data.procSEmpInfo[0].citizen_id})
   //   this.setState({ idemp: res.data.procSEmpInfo[0].employee_id})
   //   this.setState({ employee_name: res.data.procSEmpInfo[0].employee_name})
  //  })

       const building_id = value;
       this.setState({ building_id });
}


  handleChange2(event) {    this.setState({group_id: event.target.value});  }
  handleChange3(event) {    this.setState({name_room: event.target.value});  }
  handleChange4(event) {    this.setState({amount: event.target.value});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("teacher_id1", this.state.teacher_id1);
      datafrm.append("id_major", this.state.id_major);
      datafrm.append("id_course", this.state.id_course);
      datafrm.append("group_id", this.state.group_id);
    
      
   Axios.post("https://git.kpru.ac.th/FrontEnd_Tabian/load/updategroup2/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    //    console.log(res);
        if (res.status === 200) {
        //  alert("บันทึกสำเร็จ")
                  Swal.fire({
                      title: 'บันทึกข้อมูลสำเร็จ',
                      icon: 'success',
                    // showCancelButton: true,
                      confirmButtonText: 'ตกลง',
                    // cancelButtonText: 'No, keep it'
                    }).then((result) => {
                     // this.props.getclassroom();
                     window.location.href = '/Timetable'
                    })
                 }
        })
        this.toggle()
        
       // this.props.getclassroom()

}, 1000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()
 
  }

    render() {
     //   console.log(this.state.id_room)
     //   console.log(this.state.name_room)
      //  console.log(this.state.amount)
        
        return (
          <MDBContainer>
            <MDBBtn onClick={this.toggle} color="deep-purple" size="sm">แก้ไขกลุ่ม</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>แก้ไขข้อมูลห้องเรียน</MDBModalHeader>
              <MDBModalBody>
              <div>

              <p>หมู่เรียน : {this.state.id_major}</p>
              <p>รหัสวิชา : {this.state.id_course}</p>
              <p>อาจารย์ : {this.state.poname}</p>
               <p>กลุ่ม</p>   
               <MDBInput type="text"  value={this.state.group_id} onChange={this.handleChange2} outline />

             

             
              
              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >แก้ไข</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}


// https://kpruinnovation.kpru.ac.th/inno2022/download/_24ผู้ช่วยศาสตราจารย์ราตรี-โพธิ์ระวัช1.pdf